import * as PIXI from "pixi.js";
import { GameAssets } from "../util/GameAssets";

// Define an enum for the states
export enum AutoplayButtonState {
    IDLE = "IDLE",
    STOP = "STOP",
    PASSIVE = "PASSIVE",
}

export class AutoplayButton extends PIXI.Container {
    private sprite: PIXI.Sprite;
    public get Sprite() {
        return this.sprite;
    }
    private currentState: AutoplayButtonState = AutoplayButtonState.IDLE;

    constructor() {
        super();

        this.sprite = new PIXI.Sprite(GameAssets.textures.uiAtlas.textures["autoplayButton.webp"]);
        this.sprite.anchor.set(0.5);
        this.sprite.position.set(0, 0);
        this.sprite.interactive = true;
        this.sprite.on("click", this._handleClick, this);
        this.sprite.on("touchend", this._handleClick, this);

        this.addChild(this.sprite);
    }

    private _handleClick() {
        switch (this.currentState) {
            case AutoplayButtonState.PASSIVE:
                break;
            case AutoplayButtonState.IDLE:
                this.emit("autoplay");
                // this._changeState(AutoplayButtonState.STOP);
                break;
            case AutoplayButtonState.STOP:
                this.emit("stop");
                this._changeState(AutoplayButtonState.PASSIVE);
                break;
        }
    }

    public resize(data: any) { }

    private _onSpin() {
        this.sprite.alpha = 1;
        this.sprite.interactive = true;
    }

    private _onStop() { }

    private _onPassive() {
        this.sprite.alpha = 0.4;
        this.sprite.interactive = false;
    }

    private _changeState(newState: AutoplayButtonState) {
        if (this.currentState === newState) return; // No change if the same state

        // Enter logic for the new state
        this.currentState = newState;
        switch (this.currentState) {
            case AutoplayButtonState.PASSIVE:
                this._onPassive();
                break;
            case AutoplayButtonState.IDLE:
                this._onSpin();
                break;
            case AutoplayButtonState.STOP:
                this._onStop();
                break;
        }
    }
}
